import isPlainObject from 'lodash/isPlainObject';
import { useEffect, useState } from 'react';
import { useBoolean } from 'react-hanger';

const useSimpleFetch = (fetchSource: any, inputs: any[] = []) => {
  const loading = useBoolean(false);
  const [state, setState] = useState<{
    isLoaded: boolean;
    source?: any;
    data?: any;
    error?: any;
  }>({
    isLoaded: false,
  });

  const reload = () => {
    loading.setTrue();
    fetchSource()
      .then((source: any) => {
        setState({
          source,
          data: isPlainObject(source) ? source.data : undefined,
          isLoaded: true,
        });
        loading.setFalse();
      })
      .catch((err) => {
        loading.setFalse();
        setState({
          isLoaded: true,
          error: err || { msg: '请求异常' },
        });
      });
  };

  useEffect(() => {
    reload();
  }, inputs);

  return {
    reload,
    loading: loading.value,
    ...state,
  };
};

export default useSimpleFetch;
